import { useMutation } from '@tanstack/react-query';
import { putAppointment } from '../api/repository/appointment';
import { UpdateAppointmentInterface } from '../types/appointment';

type PutAppointmentProps = {
    appointmentId: number;
    updateAppointment: UpdateAppointmentInterface;
};

export const usePutAppointment = () => {
    return useMutation({
        mutationFn: ({
            appointmentId,
            updateAppointment,
        }: PutAppointmentProps) =>
            putAppointment(appointmentId, updateAppointment),
    });
};
